export default __webpack_public_path__ + "static/media/Badge_GooglePlay.6a03fbd2.svg";